document.addEventListener('DOMContentLoaded', () => {
    const processSections = Array.from(document.querySelectorAll('.process-section--neo'));
    const featureRows = Array.from(document.querySelectorAll('.features-stagger'));

    featureRows.forEach((row) => row.classList.add('is-observing'));

    if (processSections.length === 0 && featureRows.length === 0) {
        return;
    }

    const reveal = (element) => {
        element.classList.add('is-visible');
    };

    if (!('IntersectionObserver' in window)) {
        processSections.forEach(reveal);
        featureRows.forEach(reveal);
        return;
    }

    const targets = [...processSections, ...featureRows];

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            reveal(entry.target);
            observer.unobserve(entry.target);
        });
    }, {
        root: null,
        threshold: 0.2,
    });

    targets.forEach((target) => observer.observe(target));
});
